import { SystemManagementApi, useAPIQuery } from "melco-shared-logic";

export const useRoles = () => {
  return useAPIQuery(SystemManagementApi, ["roles"], async (api) => {
    const result = await api.getRoles({});

    return result.list ?? [];
  });
};
